// extracted by mini-css-extract-plugin
export default {"popover":"styles_popover__xH-nm","wrapper":"styles_wrapper__DGMM2","instructions":"styles_instructions__E4gz5"};